<template>
    <div>
        <div v-if="date" class="leading-5">
            <p>
                {{ dayjs(date).format('ll') }}
            </p>
            <p v-if="!withoutTime" class="text-sm">
                {{ dayjs(date).format('LT') }}
            </p>
        </div>
        <slot v-else name="empty">
            <span>–</span>
        </slot>
    </div>
</template>

<script setup lang="ts">
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'

dayjs.extend(localizedFormat)

defineProps<{
    date?: string
    withoutTime?: boolean
}>()
</script>
